// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"y2","a":"y3","show":"y4","header":"y5","title":"y6","close":"y7","carouselWrapper":"y8","emblaSlide":"y9"};